import { NativeActionType } from '@wix/cms-platform-integration';
import { Actions } from '@wix/component-protocol/schema';
import { getDataBindingOverrideConfig } from './getDataBindingOverrideConfig';
import { PlatformContext } from '../types';
import { Connection } from '@wix/document-services-types';

export const filterActionsByDataBindingOverrides = (
  actions: Actions,
  platformContext: PlatformContext,
): Partial<Actions> => {
  const { documentServicesAPI, editorPointerAPI, editorPointer } =
    platformContext;

  const compRef = editorPointerAPI.getDocumentPointer(editorPointer);

  const connections =
    documentServicesAPI.platform.controllers.connections.get(compRef);

  const dataBindingConnection = connections.find((connection) => {
    try {
      return JSON.parse(connection.config).type === 'dataBinding';
    } catch (e) {
      return false;
    }
  });

  if (!dataBindingConnection) {
    return actions;
  }

  const dataBindingOverrideConfig = getDataBindingOverrideConfig({
    componentType: documentServicesAPI.components.getType(compRef),
    role: dataBindingConnection?.role,
  });

  const dataBindingExcludedActions =
    dataBindingOverrideConfig?.hiddenActions || [];

  return Object.fromEntries(
    Object.entries(actions).filter(
      ([actionKey]) =>
        !dataBindingExcludedActions.includes(actionKey as NativeActionType),
    ),
  );
};
